import { ThemeIcon } from '@mantine/core'
import { Card, Stack, Text } from 'components'
import { useNavigate } from 'react-router-dom'
import type { ManagerNavCardProps } from '../interfaces'

const ICON_SIZE = 40

/** Vertical shortcut card: tinted icon on top, then title and description. */
export const ManagerNavCard = ({ icon: Icon, color, title, description, to }: ManagerNavCardProps) => {
  const navigate = useNavigate()

  return (
    <Card
      withBorder
      radius='md'
      p='lg'
      role='link'
      onClick={() => navigate(to)}
      sx={theme => ({
        cursor: 'pointer',
        transition: 'box-shadow 150ms ease, transform 150ms ease',
        '&:hover': { boxShadow: theme.shadows.sm, transform: 'translateY(-2px)' },
      })}
    >
      <Stack spacing='sm'>
        <ThemeIcon size={ICON_SIZE} radius='md' variant='light' color={color}>
          <Icon size={22} />
        </ThemeIcon>
        <div>
          <Text fw={600}>{title}</Text>
          <Text color='dimmed' size='sm'>
            {description}
          </Text>
        </div>
      </Stack>
    </Card>
  )
}
